import { create } from 'zustand';

export interface IOrganizationInfo {
  id: string | null;
  name: string | null;
  access: number | null;
}

export interface IOrganizationStore {
  organizationInfo: IOrganizationInfo;
  setOrganizationInfo: (organizationInfo: IOrganizationInfo) => void;
}

export const useOrganizationStore = create<IOrganizationStore>((set, get) => ({
  organizationInfo: {
    id: null,
    name: null,
    access: 0,
  },
  setOrganizationInfo: (organizationInfo: IOrganizationInfo) => set({ organizationInfo }),
}));
